module.exports = __webpack_public_path__ + "static/media/bn_literacy_matters.d98a49e1.png";